import React, { useState } from "react";
import { resetPasswordPageStyle } from "./resetStyle";
import SideBar from "../../sidebar-navbar";
import { useDispatch, useSelector } from "react-redux";
import { resetPasswordCode, getAuth } from "../../../store/auth";
import Loader from "../../common/Loader";
import notification from "../../common/Alert";

const ResetCode = () => {
  const classes = resetPasswordPageStyle();
  const dispatch = useDispatch();
  const [passwordResetCode, setPasswordResetCode] = useState("");
  const admin = useSelector(getAuth);

  const sendResetPassCode = async (e) => {
    e.preventDefault();
    const resetCode = await dispatch(resetPasswordCode(passwordResetCode));

    if (resetCode.payload.status === true) {
      notification.notication("success", resetCode.payload.message, "", { position: "top-right" });
      setTimeout(() => {
        window.location.replace("/new-password");
      }, 5000);
    }
  };

  return (
    <div>
      <SideBar />
      <Loader visible={admin.loading} />
      <form className={classes.formContainer} onSubmit={sendResetPassCode}>
        <p className={classes.resetP}>Verify Reset Code</p>
        <p className={classes.resetText}>Enter the six-digit code that was sent to your email address</p>
        <div className={classes.inputSection}>
          <label>
            <sup>*</sup>Verification Code
          </label>{" "}
          <br />
          <input
            type="text"
            id="code"
            name="code"
            value={passwordResetCode}
            onChange={(e) => setPasswordResetCode(e.target.value)}
            placeholder="333333"
            className={classes.formInput}
          />
        </div>
        <br />
        <button className={classes.submitform}>Confirm</button>
      </form>
    </div>
  );
};

export default ResetCode;
